<template>
  <div class="d-flex justify-center align-center flex-column">
    <div style="width: 100%; max-width: 700px;" class="pa-3 d-flex flex-column">
      <v-btn
        :dark="remainingInvitations"
        depressed
        color="green darken-2"
        @click="invite()"
        :disabled="!remainingInvitations"
        :loading="loading"
        style="width: 150px;"
      >convidar</v-btn>
      <div class="mt-6 d-flex">
        <v-select
          outlined
          hide-details
          label="Permissão"
          :items="['Administrador']"
          value="Administrador"
          readonly
          style="max-width: 170px;"
          class="mr-4"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
              </template>
              <div class="d-flex flex-column pa-3">
                <strong>Administrador:</strong>
                <div>Tem acesso à todas as ações dentro do gerenciador de todos os projetos.</div>
                <strong class="mt-2">Gerente:</strong>
                <div>Gerencia os projetos a que for atribuído, cria e edita links. Não remove links.</div>
                <strong class="mt-2">Analista:</strong>
                <div>Apenas visualiza os projetos a que for atribuído. Não cria, nem edita, nem remove links</div>
              </div>
            </v-tooltip>
          </template>
        </v-select>
        <v-text-field
          outlined
          label="Administrador (você)"
          v-model="user.email"
          hide-details
          readonly
        >
        </v-text-field>
      </div>
      <div v-for="(user, index) in user.team" :key="index" class="mt-6 d-flex">
        <v-select
          outlined
          hide-details
          label="Permissão"
          :items="['Gerente', 'Analista']"
          :value="user.role"
          @change="role => changeRole(user, role)"
          :loading="loadingRole[user.id]"
          style="max-width: 170px;"
          class="mr-4"
        ></v-select>
        <v-select
          class="mr-4"
          style="max-width: 200px; width: 100%;"
          :value="user.projects"
          @change="projects => changeProjects(user, projects)"
          :items="projects"
          item-text="name"
          item-value="id"
          label="Projetos"
          placeholder="Selecione"
          return-object
          multiple
          outlined
          hide-details
          :loading="loadingProjects[user.id]"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.name }}</span>
            </v-chip>
            <span
              v-if="index === 1"
              class="grey--text text-caption"
            >
              +{{ user.projects.length - 1 }} outro(s)
            </span>
          </template>
        </v-select>
        <v-text-field
          outlined
          :label="user.member ? 'Membro' : 'Copie o link do convite'"
          :value="user.member ? user.member.email : getInvite(user)"
          hide-details
          readonly
        >
          <template v-slot:append>
            <v-icon v-if="!user.member" class="mr-1" @click="copyStringToClipboard(getInvite(user))">mdi-content-copy</v-icon>
            <v-icon @click="destroy(user)">mdi-delete</v-icon>
          </template>
        </v-text-field>
      </div>
    </div>
    <v-snackbar v-model="copied" :timeout="2000">
      Link do convite copiado para área de transferência
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" small text v-bind="attrs" @click="copied = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>

    <zp-alert-modal v-model="modalDestroy" icon="/img/alert/remove-user.svg" @ok="destroy(destroyItem, true)" cancel>
      <div class="d-flex flex-column">
        <h3>Pense bem!</h3>
        <span class="mt-2">Tem certeza que deseja excluir? Esta ação não pode ser desfeita.</span>
      </div>
    </zp-alert-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import ZpAlertModal from '@/components/AlertModal.vue'

export default {
  components: {
    ZpAlertModal
  },
  data () {
    return {
      loading: false,
      modalDestroy: false,
      destroyItem: null,
      copied: false,
      loadingRole: {},
      loadingProjects: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      _projects: state => state.projects.data
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    },
    remainingInvitations () {
      const team = this.user.team.length + 1

      if (this.user.max_users <= team) {
        return false
      }

      return true
    },
    projects () {
      return this._projects.filter(item => item.role === 'Administrador')
    }
  },
  methods: {
    async invite () {
      this.loading = true
      try {
        await this.$store.dispatch('team/store')
      } catch (e) {
        alert(e.message)
      }
      this.loading = false
    },
    async destroy (item, confirmed) {
      if (!confirmed) {
        this.modalDestroy = true
        this.destroyItem = item
        return false
      }

      this.modalDestroy = false

      this.loading = true
      try {
        await this.$store.dispatch('team/destroy', item)
      } catch (e) {
        alert(e.message)
      }
      this.loading = false
    },
    getInvite (item) {
      return `https://gerenciador.zaper.in/#/?invite=${item.id}`
    },
    copyStringToClipboard (str) {
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copied = true
    },
    async changeRole (item, role) {
      this.loadingRole = {
        ...this.loadingRole,
        [item.id]: true
      }
      try {
        await this.$store.dispatch('team/update', {
          id: item.id,
          data: { role }
        })
      } catch (e) {
        alert(e.message)
      }
      this.loadingRole = {
        ...this.loadingRole,
        [item.id]: false
      }
    },
    async changeProjects (item, projects) {
      this.loadingProjects = {
        ...this.loadingProjects,
        [item.id]: true
      }
      try {
        await this.$store.dispatch('team/update', {
          id: item.id,
          data: { projects: projects.map(item => item.id) }
        })
      } catch (e) {
        alert(e.message)
      }
      this.loadingProjects = {
        ...this.loadingProjects,
        [item.id]: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>